import React from 'react';

import TransitionBlock from './TransitionBlock';

export default props => {
  return <TransitionBlock opacityDuration="0.8s" offsetDuration="1.5s" fromOffsetY={100} threshold={0}><img alt="" { ...props } /></TransitionBlock>
}